import { LineJumpRecord, LineJumpState, NodeRecord, NodeState } from "./modal"

export const nodeRecordToState = (node: NodeRecord): NodeState => {
  const {size, position} = node

  return {
    ...node,
    size,
    position,
  }
}

export const jumpRecordToState = (jump: LineJumpRecord): LineJumpState => {
  const {size, position} = jump
  return {
    ...jump,
    size,
    position,
  }
}
